export const tinCan4Inch = 30706;
export const tinCan5Inch = 30708;
export const tinCan7Inch = 30710;
export const flatBottomBag = 30712;
export const gussetBag = 30714;
export const gussetBagMetallic = 31306;
export const gussetBagRecyclableWhite = 31313;
export const gussetBagRecyclableClear = 31315;
export const gussetBagKraftBrown = 31318;
export const gussetBagCompostableWhite = 31323;
export const gussetBagCompostableBrown = 31321;
export const gussetBagProductIds = [
    gussetBag,
    gussetBagMetallic,
    gussetBagRecyclableWhite,
    gussetBagRecyclableClear,
    gussetBagKraftBrown,
    gussetBagCompostableWhite,
    gussetBagCompostableBrown,
];
export const standUpPouch = 30927;
export const standUpPouchWithValve = 30926;
export const coffeeBagLabel2x3 = 30973;
export const coffeeBagLabel275x4 = 30974;
export const coffeeBagLabel325x4 = 30975;
export const coffeeBagLabel4x6 = 30976;
export const sticker = 31028;
export const paperTinTieBag = 31401;
export const mailerWhite = 31398;
export const mailer = 31399;
export const mailerLargeWhite = 31400;
